import React, { FC, useEffect } from "react";
import * as appRoutes from "../../../routes/routeConstants/appRoutes";
import LocalStorage from "../../LocalStorage";
import AuthContainer from "../../../store/container/AuthContainer";
import RestrictAccess from "../RestrictedAccess";
import KYCService from "../../../services/KYCService/kyc.service";

const requireAuth = (Component: FC) => {
  const Authentication = (props?: any, allowedRoles?: any) => {
    const { user } = props;
    const { getStepperStatus } = KYCService();
    const { authenticated, history } = props || {};
    const token = LocalStorage.getItem("vuka-token");
    useEffect(() => {
      const currentPath = history?.location?.pathname;
      if (currentPath === appRoutes.ROOT || currentPath?.includes('/create-account')) {
        return;
      }
      fetchUserDetails();
    }, [props]);

    const fetchUserDetails = async () => {
      const stepData = token && (await getStepperStatus());
      if (!stepData) return;
      if (authenticated && token && stepData?.step === "completed")
        return history.push(appRoutes.HOME);
    };

    if (allowedRoles.length)
      return allowedRoles.includes(user.role) ? (
        <Component {...props} />
      ) : (
        <RestrictAccess getUserDetails={() => {}} />
      );

    return <Component {...props} />;
  };

  return AuthContainer(Authentication);
};

export const handleAuthRoute = (component: FC) => requireAuth(component);

export default handleAuthRoute;
